import {registerAllowCookieMessageHandler} from "../iframe-communication/message-handlers/seltmannCmsAllowCookie";

/**
 * initializes the re-captcha fields and load the required script if not already loaded
 * only call this script if the user has agreed to load the Google recaptcha cookies!
 */
function initCaptchas(){
  const captchaAreas = Array.from(document.querySelectorAll('.recaptcha-area'));
  captchaAreas.forEach(captchaArea => {
    const captchaHtml = captchaArea.dataset.replaceWhenCookieAllowed ?? null;
    if(captchaHtml !== null) {
      captchaArea.innerHTML = captchaHtml;
    }
  });

  const hasRecaptchaScript = document.querySelector("script[src*='google.com/recaptcha']") !== null;
  if(!hasRecaptchaScript) {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.id = 'grecaptchajs';
    document.body.appendChild(script);
  }
}

function setUpRecaptcha(){
  registerAllowCookieMessageHandler('google-recaptcha', () => initCaptchas());
}

export {initCaptchas, setUpRecaptcha};
